import React from 'react';

import { pieChart, rows } from '@/assets/icons';

import styles from './ChartEmptyState.module.scss';

interface ChartEmptyStateProps {
	emptyReason?: 'no-history' | 'date-filtered';
	copy?: string;
	icon?: 'pieChart' | 'rows';
}

const DEFAULT_COPY: Record<NonNullable<ChartEmptyStateProps['emptyReason']>, string> = {
	'no-history': 'Gather feedback on setlists to see this chart.',
	'date-filtered': 'No feedback in this period. Try extending the date range.',
};

const ICONS = { pieChart, rows };

export const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({
	emptyReason,
	copy = emptyReason ? DEFAULT_COPY[emptyReason] : DEFAULT_COPY['no-history'],
	icon = 'pieChart',
}) => {
	const IconComponent = ICONS[icon];
	return (
		<div className={styles['root']}>
			<IconComponent className={styles['icon']} />
			<p className={styles['copy']}>{copy}</p>
		</div>
	);
};
